import { Core } from "@faire/design-tokens";
import { FaireLogo } from "@faire/web/slate/icons/FaireLogo";
import { Row } from "@faire/web/slate/Layout";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
export var ChatCsatHeader = function ChatCsatHeader() {
  return /*#__PURE__*/React.createElement(SelfServeHeader, null, /*#__PURE__*/React.createElement(FaireLogoWrapper, null, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(FaireLogo, null))));
};
var SelfServeHeader = styled(Row).attrs({
  justify: "flex-start",
  align: "center"
}).withConfig({
  displayName: "ChatCsatHeader__SelfServeHeader"
})(["height:60px;padding:32px;position:relative;border-bottom:1px solid ", ";"], Core.border.muted);
var FaireLogoWrapper = styled.div.withConfig({
  displayName: "ChatCsatHeader__FaireLogoWrapper"
})(["position:absolute;margin:0;left:50%;top:50%;transform:translate(-50%,-50%);"]);